/**
 * Created by slava on 3/6/19
 */

const LineHintAlgorithm = {
    type: "lineBooster",

    findMove: function () {
        if (!Game.currentGame || !Game.currentGame.field) {
            return;
        }

        const ideas = [
            LineHintAlgorithm.completeGoalIdea,
            HintHelper.isBottomRowElement
        ];

        const move = HintHelper.findMove(ideas, cleverapps.Boosters.TYPE_LINE);
        if (move) {
            move.type = LineHintAlgorithm.type;
            move.delay = 3000;
            return move;
        }
    },

    completeGoalIdea: function (cell) {
        if (!HintHelper.isActiveGoal(cell) || !cell.hurtable) {
            return;
        }

        const goalId = cell.getGoalId();
        const remaining = HintHelper.countSameGoals(cell);

        const col = cell.col;
        let columnTotal = 0;
        for (let i = 0; i < Field.SIZE; i++) {
            cell = Game.currentGame.field.cells[i][col];
            if (cell && cell.getGoalId() === goalId) {
                columnTotal++;
            }
        }

        return columnTotal >= remaining;
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(LineHintAlgorithm);